loadPredefinedVersion(() => {
  if (window.location.pathname.includes('/kiosk')) {
    includeDynatrace();
  }
  return import('./bootstrap');
});
function loadPredefinedVersion(done) {
  try {
    const usePredefinedVersion = localStorage.getItem('vm/__usePredefinedVersions');
    if (usePredefinedVersion) {
      const { src } = document.currentScript;
      const predefinedVersion = JSON.parse(localStorage.getItem('vm/__appVersion'));
      const isCurrentlyOnPredefinedVersion = predefinedVersion && src.includes(predefinedVersion);
      if (isCurrentlyOnPredefinedVersion) {
        return done();
      }
      fetchVersions()
        .then(data => {
          const version = versionExists(data, predefinedVersion) ? predefinedVersion : getLatestMaster(data);
          const scriptToLoad = src.replace(/static_.+?(?=\/)/, `static_${version}`);
          if (!version || scriptToLoad === src) return done();
          return createScript(scriptToLoad);
        })
        .catch(e => {
          console.log('err', e);
          disablePredefinedVersions();
          window.location.reload();
        });
      return undefined;
    }
  } catch (e) {
    console.log(e);
  }
  return done();
}

function fetchVersions() {
  return fetch('/versions.json').then(response => response.json());
}

function disablePredefinedVersions() {
  localStorage.removeItem('vm/__usePredefinedVersions');
  localStorage.removeItem('vm/__appVersion');
}

function getLatestMaster(versions) {
  const { version } = versions.find(({ origin }) => origin === 'master');
  return version;
}

function versionExists(versions, v) {
  return versions.some(({ version }) => version === v);
}

function jsFileExist(src) {
  return fetch(src).then(({ headers }) => {
    if (!headers.get('Content-Type').includes('application/javascript')) {
      throw new Error(`${src} is not a js file`);
    }
  });
}

async function createScript(src) {
  await jsFileExist(src);
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.getElementsByTagName('body')[0].appendChild(script);
  });
}

function includeDynatrace() {
  try {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://js-cdn.dynatrace.com/jstag/16827775e4e/bf43049pnl/${getDynatraceTag()}.js`;
    script.crossOrigin = 'anonymous';
    document.getElementsByTagName('body')[0].appendChild(script);
  } catch (e) {
    console.error(e);
  }
}

function getDynatraceTag() {
  const { origin } = window.location;
  /**
   * can't move this to config.json because it's loaded later, so hardcoding it here
   * */
  if (['localhost', '.vmos-demo.com', '.vmos-qa.com'].some(host => origin.includes(host))) {
    // demo app
    return '3cd207dd14b3f269_complete';
  }
  // live app
  return '4b8ba996bdc4ce42_complete';
}
